













import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component
export default class InvoiceActions extends Mixins(Context) {
  // Inject

  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;

  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  // Computed

  public get $invoice() {
    return this.$invoiceProvider();
  }

  public get actions() {
    return [
      {
        label: this.$t("_.pay_invoice"),
        method: () => this.$invoiceMethods.pay(),
        if: this.$invoice.isPayable
      },
      {
        label: this.$t("_action.credit_refund_invoice"),
        method: this.$invoiceMethods.openCreditRefundModal,
        if: this.isAdmin && this.$invoice.hasCreditRefundOptions
      },
      {
        label: this.$t("_.regenerate_invoice"),
        method: () => this.$invoiceMethods.openRegenerateInvoiceModal(),
        if: true
      },
      {
        label: this.$t("_action.change_object", {
          object: (this.$t("_.due_date") as string).toLowerCase()
        }),
        method: this.$invoiceMethods.openDueDateModal,
        if: this.isAdmin && this.$invoice.isPayable
      },
      {
        label: this.$t(
          this.$invoice.hasPaymentMethod
            ? "_action.change_object"
            : "_action.select_object",
          {
            object: (this.$t("_.payment_method") as string).toLowerCase()
          }
        ),
        method: () => this.$invoiceMethods.openChangePaymentMethodModal(),
        if: this.$invoice.isPayable
      },
      {
        label: this.$t("_action.send_email"),
        method: this.$invoiceMethods.openSendEmailModal,
        if: () => true
      },
      {
        label: this.$t("_action.create_order_template"),
        method: this.$invoiceMethods.createOrderTemplate,
        if: this.isAdmin && this.$userCan("store_invoice_template")
      }
    ];
  }

  public get availableActions() {
    return this.$_.filter(this.actions, action => action.if);
  }
}
